import { Col, Container, Row } from "react-bootstrap";
import Reward_animation from "../../animations/rewards_animation/Reward_animation";

// Correct JSON imports
import RewardJSON from "../../animations/rewards_animation/Reward_animation.json";
import ReferJSON from "../../animations/rewards_animation/Refer_animation.json";
import OfferJSON from "../../animations/rewards_animation/Offer_animation.json";
import CashbackJSON from "../../animations/rewards_animation/Cashback_animation.json";

import "./Rewards.css";

const Rewards = () => {
  const features = [
    {
      title: "Rewards",
      text: "Earn cashback and exclusive benefits on every transaction",
      animation: RewardJSON,
    },
    {
      title: "Refer & Earn",
      text: "Invite friends & earn exciting rewards on every referral",
      animation: ReferJSON,
    },
    {
      title: "Offers",
      text: "Save more with special deals & discounts on every recharge & payment.",
      animation: OfferJSON,
    },
    {
      title: "Cashback",
      text: "Save while you spend and enjoy rewards on all your payments",
      animation: CashbackJSON,
    },
  ];

  return (
    <section className="features-section section_margin">
      <Container>
        <Row>
          {features.map((item, index) => (
            <Col md={6} sm={6} xs={12} key={index}>
              <div className="feature-box">
                <div className="feature">
                  <Row className="align-items-center">
                    <Col xs={9}>
                      <h4 className="feature-title">{item.title}</h4>
                      <p className="feature-text">{item.text}</p>
                    </Col>
                    <Col xs={3}>
                      <div className="lottie">
                        <Reward_animation animationData={item.animation} />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Rewards;
